module.exports = __webpack_public_path__ + "8b7a19fcc72c8a6bc5a5553a2382c1a6.MP3";